<template>
  <div class="header">
    <tabbar v-model="active" @change="onChange">
      <tabbar-item :icon="active === 0 ? business_hall_selected1 : business_hall1"
        >首页</tabbar-item
      >
      <!-- <tabbar-item :icon="active === 1 ? business_handling_selected : business_handling">业务</tabbar-item> -->
      <tabbar-item :icon="active === 1 ? news_selected : news">公告</tabbar-item>
      <tabbar-item :icon="active === 2 ? business_handling_selected : business_handling"
        >新闻</tabbar-item
      >
      <tabbar-item :icon="active === 3 ? my_selected : my"
        >我的
        <!-- <van-badge class="mindNum" v-if="elecNum > 0" :content="elecNum" max="99"/> -->
      </tabbar-item>
      <!-- <tabbar-item :icon="active === 4 ? mobile_assistant_selected : mobile_assistant">移动助手</tabbar-item> -->
    </tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from 'vant';
import business_handling from '@/assets/icon1/business_ handling.png';
import business_handling_selected from '@/assets/icon1/business_handling_selected.png';
import business_hall from '@/assets/icon1/business_hall.png';
import business_hall_selected from '@/assets/icon1/business_hall_selected.png';
import business_hall1 from '@/assets/icon1/business_hall1.png';
import business_hall_selected1 from '@/assets/icon1/business_hall_selected1.png';
import news from '@/assets/icon1/news1.png';
import news_selected from '@/assets/icon1/news_selected1.png';
import my from '@/assets/icon1/my_selected.png';
import my_selected from '@/assets/icon1/my_selected1.png';
import mobile_assistant from '@/assets/icon1/mobile_assistant.png';
import mobile_assistant_selected from '@/assets/icon1/mobile_assistant_selected.png';

const PATH = [
  { key: 0, path: '/' },
  { key: 2, path: '/NewsNotice/NewsNoticeClassify' },
  { key: 1, path: '/NoticePage/index' },
  { key: 3, path: '/UserCenterPage/index' }
];

export default {
  name: 'MyFooter',
  data() {
    return {
      active: 0,
      business_hall1,
      business_hall_selected1,
      business_handling,
      business_handling_selected,
      business_hall,
      business_hall_selected,
      news,
      news_selected,
      my,
      my_selected,
      mobile_assistant,
      mobile_assistant_selected,
      progressNum: 0,
      elecNum: 0
    };
  },
  components: {
    Tabbar,
    TabbarItem
  },
  watch: {
    $route: {
      handler(to, from) {
        let activeTab = PATH.find(item => item.path === to.path);
        if (activeTab) {
          this.active = activeTab.key;
        }
      },
      immediate: true
    }
  },
  methods: {
    onChange(val) {
      let path;
      let query;
      console.log(val);
      switch (val) {
        case 0:
          path = '/';
          break;
        case 2:
          path = '/NoticePage/NewsList';
          break;
        case 1:
          path = '/NewsNotice/NewsNoticeClassify';
          break;
        case 3:
          // this.toUserCenter();
          path = '/UserCenterPage/index';
          break;
        case 4:
          // path = "/UserCenterPage/index";
          break;
      }
      this.$router.push({ path });
    },
    async toUserCenter() {
      // const { phoneNumber } = loadUserInfo();
      // let result = loadStaffToken();
      // await this.$store.dispatch("staff/getIsHaveJurisdiction", { phoneNumber, result });
      await this.$router.push({
        path: '/UserCenterPage/index'
      });
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  height: 84px;
  // border-top-left-radius: 40px; //设置左上角
  // border-top-right-radius: 40px; //设置右上角
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  .header-div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 19px;
  }

  .mindNum {
    position: absolute;
    top: 5px;
    right: 50px;
  }

  .van-tabbar-item--active {
    color: #141124;
  }
}
</style>
